import {
  useCreateRecord,
  useFind,
  useFindRecord,
  useUpdateRecord,
  useInvalidateQueries,
} from 'src/api/APIHooks';
import { defaultPagingQueryConfig, defaultQueryConfig, defaultMutationConfig } from '../apiHookOptions';

export const useFindDirectory = (id) => useFindRecord('directories', id, {
  queryConfig: { ...defaultQueryConfig, placeholderData: undefined },
  api: 'prdAdminApi',
});

export const useFindDirectories = (options) => useFind(
  'directories',
  options?.filter || {},
  {
    queryConfig: {
      ...defaultPagingQueryConfig,
      placeholderData: undefined,
    },
    api: 'prdAdminApi',
    ...options,
  },
);

export const useCreateDirectory = (mutationConfig) => {
  const invalidateQueries = useInvalidateQueries();
  return useCreateRecord('directories', {
    mutationConfig: {
      onSuccess: () => {
        invalidateQueries('directories');
      },
      ...defaultMutationConfig,
      ...mutationConfig,
    },
    api: 'prdAdminApi',
  });
};

export const useUpdateDirectory = (mutationConfig) => {
  const invalidateQueries = useInvalidateQueries();
  return useUpdateRecord('directories', {
    mutationConfig: {
      onSuccess: () => {
        invalidateQueries('directories');
      },
      ...defaultMutationConfig,
      ...mutationConfig,
    },
    api: 'prdAdminApi',
  });
};
